// ============================================
// TTS 모듈 진입점 (ES6)
// Gemini-TTS 사용 (Cloud Run에서 API 키 관리)
// ============================================

// State exports
export {
  getTtsEnabled,
  setTtsEnabled,
  getCurrentVoiceId,
  setCurrentVoiceId,
  getIsPlaying,
  resetTtsState
} from './state.js';

// API exports
export {
  synthesizeSpeech,
  previewTTS,
  cleanTextForTTS,
  splitIntoSentences,
  extractDialogueOnly,
  getVoicePresetList,
  getVoicesByGender
} from './api.js';

// Queue exports
export {
  processStreamingText,
  flushPendingText,
  playNextInQueue,
  clearQueue
} from './queue.js';

// Player exports
export {
  playAudio,
  pauseAudio,
  resumeAudio,
  stopAllAudio,
  setVolume,
  getVolume,
  isCurrentlyPlaying,
  getQueueLength,
  unlockAudio,
  playAudioFromDataUrl
} from './player.js';

// ============================================
// 통합 초기화 함수
// ============================================

import { setCurrentVoiceId, setTtsEnabled, resetTtsState } from './state.js';
import { clearQueue } from './queue.js';
import { getCurrentChatData } from '../../app/state.js';

/**
 * TTS 모듈 초기화 (Gemini-TTS - API 키는 Cloud Run에서 관리)
 */
export function initTTS() {
  console.log('[TTS] Gemini-TTS 모듈 초기화 완료');
}

// 기본 음성 (성별별)
const DEFAULT_VOICE = {
  female: 'zephyr',   // 제퍼 (여성)
  male: 'charon'      // 카론 (남성)
};

/**
 * 채팅 시작 시 TTS 설정
 * 캐릭터의 voiceId를 로드하고 상태 초기화
 * voiceId 없으면 성별에 따라 기본 음성 할당
 */
export function setupTTSForChat() {
  resetTtsState();

  const chatData = getCurrentChatData();
  const character = chatData?.character;
  let voiceId = character?.voiceId;

  if (voiceId) {
    setCurrentVoiceId(voiceId);
    console.log('[TTS] 음성 설정:', voiceId);
  } else {
    // 성별에 따라 기본 음성 할당
    const gender = character?.gender || 'female';
    voiceId = DEFAULT_VOICE[gender] || DEFAULT_VOICE.female;
    setCurrentVoiceId(voiceId);
    console.log('[TTS] 기본 음성 설정:', voiceId, '(성별:', gender + ')');
  }
}

/**
 * 채팅 종료 시 TTS 정리
 */
export function cleanupTTS() {
  clearQueue();
  resetTtsState();
}

/**
 * TTS 토글 (켜기/끄기)
 */
export function toggleTTS() {
  const { getTtsEnabled, setTtsEnabled } = require('./state.js');
  const newState = !getTtsEnabled();
  setTtsEnabled(newState);

  if (!newState) {
    clearQueue();
  }

  return newState;
}
